import { Link as FluentLink } from "@fluentui/web-components";
/**
 * Link
 * @summary A Link Custom HTML Element based on Fluent UI's Link with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-link href="https://example.com" appearance="subtle">
 *   Visit Example
 * </fabric-link>
 * ```
 *
 * @attr {LinkAppearance} appearance - The appearance the link should have.
 * @attr {boolean | undefined} inline - The link is inline with text. In chromium browsers, if the link is contained within a semantic text element (`h1`, `h2`, `h3`, `h4`, `h5`, `h6`, `p`) or `fluent-text`, `:host-context()` ensures inline links are styled appropriately.
 * @attr {string | undefined} download - Prompts the user to save the linked URL.
 * @attr {string | undefined} href - The URL the hyperlink references.
 * @attr {string | undefined} hreflang - Hints at the language of the referenced resource.
 * @attr {string | undefined} ping - The ping attribute.
 * @attr {string | undefined} referrerpolicy - The referrerpolicy attribute. See The `referrerpolicy` attribute.
 * @attr {string | undefined} rel - The rel attribute. See The `rel` attribute.
 * @attr {string | undefined} target - The target attribute.
 * @attr {string | undefined} type - The type attribute.
 *
 * @prop {string} appearance - The appearance the link should have.
 * @prop {boolean} inline - The link is inline with text. In chromium browsers, if the link is contained within a semantic text element (`h1`, `h2`, `h3`, `h4`, `h5`, `h6`, `p`) or `fluent-text`, `:host-context()` ensures inline links are styled appropriately.
 * @prop {string} download - Prompts the user to save the linked URL.
 * @prop {string} href - The URL the hyperlink references.
 * @prop {string} hreflang - Hints at the language of the referenced resource.
 * @prop {string} ping - The ping attribute.
 * @prop {string} referrerpolicy - The referrerpolicy attribute. See The `referrerpolicy` attribute.
 * @prop {string} rel - The rel attribute. See The `rel` attribute.
 * @prop {string} target - The target attribute.
 * @prop {string} type - The type attribute.
 *
 * @slot - The default slot for link content.
 * @slot start - Content which can be provided before the link content
 * @slot end - Content which can be provided after the link content
 *
 * @csspart control - The anchor element.
 * @csspart content - The element wrapping anchor content.
 *
 * @method keydownHandler - Handles keydown events for the anchor.
 *
 * @extends FluentLink
 * @tagname fabric-link
 * @public
 */
export class Link extends FluentLink {
}
//# sourceMappingURL=link.js.map